import { Modal, Table } from "react-bootstrap";
import { formatSalesValue } from "../../utils/formatUtils";
import { useEffect, useRef, useState } from "react";
import PrintableInvoice from "./PrintableInvoice";
import axios from "axios";
import ExportableInvoice from "./ExportableInvoice";
import { PDFDownloadLink } from "@react-pdf/renderer";

const BillDetail = ({ showModal, handleCloseModal, billInfoList, billInfo, selected }) => {
    const componentRef = useRef();
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem('token');
    const logo = sessionStorage.getItem('selectedLogo');
    const [logoSrc, setLogoSrc] = useState('/logo.jpg');
    const [isImageLoaded, setIsImageLoaded] = useState(false);
    const [imageLoadError, setImageLoadError] = useState(false);

    useEffect(() => {
        const fetchImage = async () => {
            if (!logo) {
                setIsImageLoaded(true);
                return;
            }

            try {
                const response = await axios.get(`${baseUrl}/static/uploads/${logo}`, {
                    responseType: 'blob',
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                const reader = new FileReader();
                reader.onload = () => {
                    setLogoSrc(reader.result);
                    setIsImageLoaded(true);
                };
                reader.onerror = () => {
                    console.error("Failed to read logo image");
                    setImageLoadError(true);
                    setIsImageLoaded(true);
                };
                reader.readAsDataURL(response.data);
            } catch (error) {
                console.error("Failed to fetch logo:", error);
                setImageLoadError(true);
                setIsImageLoaded(true);
            }
        };

        fetchImage();
    }, [logo, baseUrl, token]);

    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        printWindow.document.write(`
            <html>
                <head>
                    <title>Invoice - ${billInfo.bill_no}</title>
                    <script src="https://cdn.tailwindcss.com"></script>
                </head>
                <body>
                    ${componentRef.current.innerHTML}
                </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 500);
    };

    return (
        <Modal show={showModal} onHide={handleCloseModal} size="md">
            <Modal.Header closeButton>
                <Modal.Title className="w-100 text-center">
                    {selected}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {billInfo && (
                    <>
                        <div className="space-y-2 mb-4">
                            <div className="font-semibold text-center">Invoice</div>
                            <div className="flex justify-between">
                                <span className="font-semibold">Bill No:</span>
                                <span>{billInfo.bill_no}</span>
                            </div>
                            <div className="flex justify-between">
                                <span className="font-semibold">Start Time:</span>
                                <span>{billInfo.Start_Time}</span>
                            </div>
                            <div className="flex justify-between">
                                <span className="font-semibold">End Time:</span>
                                <span>{billInfo.End_Time}</span>
                            </div>
                            <div className="flex justify-between">
                                <span className="font-semibold">Type:</span>
                                <span>{billInfo.Type}</span>
                            </div>
                            <div className="flex justify-between">
                                <span className="font-semibold">Table No:</span>
                                <span>{billInfo.Table_No}</span>
                            </div>
                            <div className="flex justify-between">
                                <span className="font-semibold">Employee:</span>
                                <span>{billInfo.employee}</span>
                            </div>
                            <div className="flex justify-between">
                                <span className="font-semibold">Payment Mode:</span>
                                <span>{billInfo.PaymentMode}</span>
                            </div>
                            {billInfo.NoOfGuests && (
                                <div className="flex justify-between">
                                    <span className="font-semibold">No. of Guests:</span>
                                    <span>{billInfo.NoOfGuests}</span>
                                </div>
                            )}
                        </div>

                        <Table striped bordered hover responsive className="text-sm">
                            <thead>
                                <tr>
                                    <th>Item Name</th>
                                    <th>Rate</th>
                                    <th>Qty</th>
                                    <th>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {!billInfoList?.error &&
                                    billInfoList.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.itemName}</td>
                                            <td>{formatSalesValue(item.itemrate)}</td>
                                            <td>{item.Quantity}</td>
                                            <td>{formatSalesValue(item.total)}</td>
                                        </tr>
                                    ))}
                            </tbody>
                        </Table>

                        <div className="text-right mt-4">
                            <p>Service Charge: {formatSalesValue(billInfo.serviceCharge)}</p>
                            <p>VAT: {formatSalesValue(billInfo.vat)}</p>
                            <p className="font-bold">Total: {formatSalesValue(billInfo.total)}</p>
                            <p className="font-bold">(After Discount)</p>
                        </div>
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-primary" onClick={handlePrint}>
                    Print
                </button>
                <PDFDownloadLink
                    document={<ExportableInvoice billInfo={billInfo} billInfoList={billInfoList} logoSrc={logoSrc} />}
                    fileName={`invoice_${billInfo.bill_no}.pdf`}
                >
                    {({ loading }) => (
                        <button disabled={loading} className="btn btn-primary">
                            {loading ? "Preparing..." : "Download PDF"}
                        </button>
                    )}
                </PDFDownloadLink>
                <button className="btn btn-secondary" onClick={handleCloseModal}>
                    Close
                </button>

                <div
                    style={{
                        position: "absolute",
                        left: "-9999px",
                        top: "0",
                        zIndex: "-1",
                        background: "#fff"
                    }}
                >
                    <PrintableInvoice
                        ref={componentRef}
                        billInfo={billInfo}
                        billInfoList={billInfoList}
                        logoSrc={imageLoadError ? '/logo.jpg' : logoSrc}
                    />
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default BillDetail;